import apiClient from '../appConfig/interceptor';
import { endpoints } from '../utils/constants';

const getTeamMember = (selectedProduct:string, teamName: string)=>apiClient.get(`${endpoints.pathPrefix}${selectedProduct}/team/${teamName}/member`);
const saveTeamMember = (selectedProduct:string, teamName: string, data: any)=>apiClient.put(`${endpoints.pathPrefix}${selectedProduct}/team/${teamName}/member`, data);
const deleteTeamMember = (selectedProduct:string, teamName: string, teamMember: string)=>apiClient.delete(`${endpoints.pathPrefix}${selectedProduct}/team/${teamName}/member/${teamMember}`);

const teamMemberConfig = {
    getTeamMember,
    saveTeamMember,
    deleteTeamMember
};
export default teamMemberConfig;